/**
 * Archivo: assets/recargo-login-enforcer.js
 * Propósito: Forzar login si el usuario necesita recargo de equivalencia
 */

(function() {
  'use strict';
  
  const DEBUG_MODE = true; // Cambiar a false en producción
  
  function debugLog(message, data) {
    if (DEBUG_MODE) {
      if (data !== undefined) {
        console.log(message, data);
      } else {
        console.log(message);
      }
    }
  }
  
  // Esperar a que ShopifyRecargo esté disponible
  if (typeof window.ShopifyRecargo === 'undefined') {
    console.error('recargo-detector.js debe cargarse antes que recargo-login-enforcer.js');
    return;
  }
  
  const { needsRecargo, isLoggedIn } = window.ShopifyRecargo;
  
  debugLog('Estado actual:', { needsRecargo, isLoggedIn });
  
  // Solo actuar si necesita recargo Y NO está logueado
  if (needsRecargo && !isLoggedIn) {
    debugLog('⚠️ Usuario necesita recargo pero no está logueado - Activando modal');
    showLoginModal();
    blockAddToCartButtons();
    blockCheckoutButtons();
  } else {
    debugLog('✓ Usuario no requiere intervención');
  }
  
  /**
   * Muestra el modal de login obligatorio
   */
  function showLoginModal() {
    // Evitar crear múltiples modales
    if (document.getElementById('recargo-login-modal')) {
      debugLog('Modal ya existe, no se crea duplicado');
      return;
    }
    
    const modal = document.createElement('div');
    modal.id = 'recargo-login-modal';
    modal.className = 'recargo-modal-overlay';
    
    const currentPath = window.location.pathname;
    const returnUrl = encodeURIComponent(currentPath);
    
    modal.innerHTML = `
      <div class="recargo-modal-content">
        <div class="recargo-modal-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <rect x="3" y="11" width="18" height="11" rx="2" ry="2"></rect>
            <path d="M7 11V7a5 5 0 0 1 10 0v4"></path>
          </svg>
        </div>
        <h3 class="recargo-modal-title">Inicio de sesión requerido</h3>
        <p class="recargo-modal-text">
          Para aplicar correctamente el <strong>recargo de equivalencia</strong> 
          en tu pedido, necesitas iniciar sesión con tu cuenta.
        </p>
        <p class="recargo-modal-subtext">
          Este recargo se aplica automáticamente según la normativa fiscal.
        </p>
        <a href="/account/login?return_url=${returnUrl}" 
           class="button button--outline button--regular button--loader">
          Iniciar sesión
        </a>
        <button class="recargo-modal-close" onclick="this.closest('.recargo-modal-overlay').style.display='none'">
          Continuar navegando sin comprar
        </button>
      </div>
    `;
    
    document.body.appendChild(modal);
    debugLog('✓ Modal de login creado');
    
    // Prevenir scroll del body cuando el modal está abierto
    document.body.style.overflow = 'hidden';
  }
  
  /**
   * Bloquea los botones de añadir al carrito
   */
  function blockAddToCartButtons() {
    // Selectores comunes en themes de Shopify
    const selectors = [
      'button[name="add"]',
      '.product-form__submit',
      '[data-action="add-to-cart"]',
      '.btn--add-to-cart',
      'button[type="submit"][name="add"]',
      '.product-form button[type="submit"]',
      '[data-add-to-cart]'
    ];
    
    const buttons = document.querySelectorAll(selectors.join(', '));
    
    debugLog(`Bloqueando ${buttons.length} botones de añadir al carrito`);
    
    buttons.forEach(button => {
      button.disabled = true;
      button.style.opacity = '0.5';
      button.style.cursor = 'not-allowed';
      button.setAttribute('title', 'Debes iniciar sesión para comprar');
      
      // Prevenir clicks
      button.addEventListener('click', preventAction, true);
      button.addEventListener('submit', preventAction, true);
    });
  }
  
  /**
   * Bloquea los botones y enlaces de checkout
   */
  function blockCheckoutButtons() {
    // Selectores para checkout
    const selectors = [
      'button[name="checkout"]',
      '.cart__checkout',
      '.cart__checkout-button',
      '[href*="/checkout"]',
      'button[type="submit"][name="checkout"]',
      '[data-checkout-button]',
      'a[href="/checkout"]',
      '.button--checkout'
    ];
    
    const elements = document.querySelectorAll(selectors.join(', '));
    
    debugLog(`Bloqueando ${elements.length} elementos de checkout`);
    
    elements.forEach(element => {
      // Si es un enlace
      if (element.tagName === 'A') {
        element.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          showLoginModal();
        }, true);
        
        element.style.opacity = '0.5';
        element.style.cursor = 'not-allowed';
      } 
      // Si es un botón
      else {
        element.disabled = true;
        element.style.opacity = '0.5';
        element.style.cursor = 'not-allowed';
        
        element.addEventListener('click', preventAction, true);
        element.addEventListener('submit', preventAction, true);
      }
    });
  }
  
  /**
   * Previene la acción y muestra el modal
   */
  function preventAction(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();
    showLoginModal();
    return false;
  }
  
  /**
   * Observer para detectar nuevos botones añadidos dinámicamente
   * (útil para themes con Ajax Cart o infinite scroll)
   */
  if (typeof window.MutationObserver !== 'undefined') {
    const observer = new MutationObserver(() => {
      if (needsRecargo && !isLoggedIn) {
        blockAddToCartButtons();
        blockCheckoutButtons();
      }
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    debugLog('✓ Observer activado para nuevos elementos');
  }
  
})();


/* =========================================================================
 * COMPUERTA DE LA PÁGINA VIEJA — v2.1, 11-sep-2026
 * =========================================================================
 *
 * EL FALLO QUE CIERRA (pedido #35171, 10-sep-2026)
 * La clienta tenía el carrito montado del día anterior. A las 13:19 se le puso la
 * etiqueta `recargo-equivalencia`; a las 13:44 pagó. Su página venía servida de
 * antes, así que el HTML todavía traía el botón de checkout NORMAL en vez del de
 * pedido oficial (#recargo-checkout-button), que es el único camino que aplica el
 * recargo. El pedido entró como `web` en vez de `shopify_draft_order` y se quedaron
 * sin cobrar 3,21 € que la factura sí llevaba: los puso la empresa. Desde el 24-jul
 * habían pasado otros cuatro por la misma puerta (#32364, #32482, #32922, #33903).
 *
 * POR QUÉ NO VALE MIRAR LO QUE TRAE LA PÁGINA
 * `window.ShopifyCustomer` y la marca de localStorage de recargo-detector.js se
 * pintan con el estado del momento en que se sirvió la página. En una página vieja
 * mienten las dos.
 *
 * POR QUÉ NO VALE PREGUNTAR A /apps/recargo/calculate (la v1, revertida el 10-sep)
 * Ese endpoint es una calculadora: con carrito lleno contesta needsRecargo:true a
 * CUALQUIERA, tenga o no la etiqueta. Solo funciona porque quien lo llamaba ya sabía
 * a quién preguntaba. Usado como juez, habría bloqueado el pago a toda clienta
 * identificada.
 *
 * LO QUE SÍ VALE
 * Pedir al servidor una página de carrito recién renderizada. El propio Liquid
 * (cart-subtotal.liquid) pinta id="recargo-checkout-button" solo si la clienta lleva
 * la etiqueta AHORA. Se busca ese id exacto, entre comillas: el nombre a secas
 * aparece también en el <script src=...recargo-checkout-button.js> y da falso
 * positivo. Comprobado el 10-sep contra la tienda: clienta normal, 0 apariciones.
 *
 * CÓMO FALLA
 * Abierto, siempre. A los 2,5 s se deja pasar el pedido pase lo que pase con la
 * petición — es una carrera contra un reloj propio, no solo el abort del fetch: en
 * la prueba D del 11-sep un fetch que ignoraba el abort dejaba el clic tragado para
 * siempre. Perder una venta por un guardián caído sale más caro que el recargo que
 * se intenta salvar.
 * ========================================================================= */

(function () {
  'use strict';

  var TIMEOUT_MS = 2500;
  var MARCA = 'id="recargo-checkout-button"';

  // Si la página ya trae el botón de pedido oficial, está bien servida: nada que vigilar.
  if (document.getElementById('recargo-checkout-button')) return;

  // Solo miramos a quien viene identificada. Un carrito anónimo no puede llevar un
  // código de mayorista (Shopify los tiene restringidos a su clienta), así que no
  // puede caer en este fallo, y no le añadimos ni una llamada de red.
  var cliente = window.ShopifyCustomer;
  if (!cliente || !cliente.isLoggedIn) return;

  var yaComprobado = false;
  var comprobando = false;

  var SALIDAS = [
    '#CheckOut',
    'button[name="checkout"]',
    'input[name="checkout"]',
    '.cart__checkout',
    '.cart__checkout-button',
    '.button--checkout',
    '[data-checkout-button]',
    'a[href="/checkout"]',
    '[href*="/checkout"]'
  ].join(', ');

  /** ¿Una página de carrito recién servida pinta el botón oficial? Entonces va en recargo AHORA. */
  function enRecargoAhora() {
    var ctrl = new AbortController();

    var consulta = fetch('/cart', {
      credentials: 'same-origin',
      cache: 'no-store',
      signal: ctrl.signal,
      headers: { 'Accept': 'text/html' }
    })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) { return typeof html === 'string' && html.indexOf(MARCA) !== -1; })
      .catch(function () { return false; }); // red, servidor caído, abort: se deja pasar

    // Reloj propio: gane quien gane, a los 2,5 s hay respuesta. No se confía en que
    // el abort llegue a rechazar el fetch.
    var reloj = new Promise(function (resolve) {
      setTimeout(function () { ctrl.abort(); resolve(false); }, TIMEOUT_MS);
    });

    return Promise.race([consulta, reloj]);
  }

  function avisar() {
    if (document.getElementById('recargo-stale-modal')) return;

    var modal = document.createElement('div');
    modal.id = 'recargo-stale-modal';
    modal.className = 'recargo-modal-overlay';
    modal.innerHTML =
      '<div class="recargo-modal-content">' +
        '<h3 class="recargo-modal-title">Tu pedido necesita el recargo de equivalencia</h3>' +
        '<p class="recargo-modal-text">Esta p&aacute;gina se abri&oacute; antes de que tu cuenta pasara a <strong>recargo de equivalencia</strong>. Si sigues por aqu&iacute;, el pedido saldr&iacute;a sin el recargo y la factura no cuadrar&iacute;a.</p>' +
        '<p class="recargo-modal-subtext">Recarga la p&aacute;gina y termina desde el bot&oacute;n &laquo;Realizar pedido&raquo;. El carrito no se pierde.</p>' +
        '<button type="button" class="button button--solid button--regular" id="recargo-stale-reload">Recargar y continuar</button>' +
      '</div>';

    document.body.appendChild(modal);
    document.body.style.overflow = 'hidden';

    var boton = document.getElementById('recargo-stale-reload');
    if (boton) {
      boton.addEventListener('click', function () {
        window.location.href = '/cart';
      });
    }
  }

  document.addEventListener('click', function (e) {
    if (yaComprobado || comprobando) return;

    var destino = e.target && e.target.closest ? e.target.closest(SALIDAS) : null;
    if (!destino) return;

    // El botón de pedido oficial nunca se toca.
    if (destino.id === 'recargo-checkout-button' || destino.closest('#recargo-checkout-button')) return;

    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    comprobando = true;
    var textoOriginal = destino.textContent;
    if (destino.tagName === 'BUTTON') destino.textContent = 'Comprobando...';

    enRecargoAhora().then(function (hayRecargo) {
      comprobando = false;
      if (destino.tagName === 'BUTTON') destino.textContent = textoOriginal;

      if (hayRecargo) {
        avisar();
        return;
      }

      // Vía libre: se repite el clic original y esta vez no lo interceptamos.
      yaComprobado = true;
      destino.click();
    });
  }, true);
})();
